import React, { useEffect, useState } from 'react';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import { Link } from 'react-router-dom';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import translate from '../../helpers/translate';
import ListProducts from './ListProducts';
import EntreesScreen from './entrees';
import DrinksScreen from './drinks';
import BreakFastScreen from './breakfast';
import MexicamScreen from './mexicam';
import DetailProduct from './DetailProduct';
import SaladasScreen from './salads';
import SandwichesScreen from './sandwich';

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);
    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showEntress, setShowEntress] = useState(false);
    const [showSandwiches, setShowSandwiches] = useState(false);
    const [showSaladas, setShowSaladas] = useState(false);
    const [showDrinks, setShowDrinks] = useState(false);
    const [showBreakFast, setShowBreakFast] = useState(false);
    const [showMexicam, setShowMexicam] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [dataDesserts, setDataDesserts] = useState(false);
    
    const [datasteak, setdatasteak] = useState(false);
    const [grilled, setgrilled] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    const [dataDrinks, setDataDrinks] = useState(false);

    const [colobmian, setcolobmian] = useState(false);
    const [bandeja, setbandeja] = useState(false);
    const [cholado, setcholado] = useState(false);
    const [fish, setfish] = useState(false);
    const [pulpo, setpulpo] = useState(false);
    

    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);

      useEffect(() => {
          menus.map((item) => {
          if (item.id === 586) {
              setDataDesserts(item);
          }
  
          if (item.id === 588) {
              setDataDrinks(item);
          }
              
          if (item.id === 574) {
              setdatasteak(item.menus);
          }
               if (item.id === 579) {
              setcolobmian(item.menus);
               }
               if (item.id === 577) {
                setfish(item);
               }
          });
      }, [menus]);
    
    
    useEffect(() => {

        if (dataDesserts) {
            dataDesserts.menus.map((item) => {
                if (item.id === 4882) {
                setcholado(item);
                }
            });
        }
        
    }, [dataDesserts])

    useEffect(() => {

        if (fish) {
            fish.menus.map((item) => {
                if (item.id === 6895) {
                setpulpo(item);
                }
            });
        }
        
    }, [fish])


    useEffect(() => {

        if (colobmian) {
            colobmian.map((item) => {
                if (item.id === 4823) {
                setbandeja(item);
                }
            });
        }
        
    }, [colobmian])


        
    useEffect(() => {
    if (datasteak) {
      datasteak.map((item) => {
        if (item.id === 4763) {
          setgrilled(item);
        }
         
      });
    }
  }, [datasteak]);
    
    
    
    const fetchImage = async (id) => {
        const imageBlob = await getImage(id);
        if (imageBlob) {
            const imageURL = URL.createObjectURL(imageBlob.blob);
            console.log('URL de la imagen:', imageURL);
            return imageURL;
        }
        return null;
    };

    const Categorie =({ data }) => {
        const [image, setImage] = useState(false);
        useEffect(() => {
            fetchImage(`menu-image-${data.id}`).then((url) => {
                if (url) {
                    setImage(url);
                }
            });
        }, []);
        
        return (

            <div  style={
                {
                    width: 160,
                    height: 42,
                    borderRadius: 5,
                    marginBottom: 10,
                    borderColor: '#efa740',
                    borderWidth: 2,
                    borderStyle: 'solid'
                }
            }>
                <div onClick={() => {
                    if (data.id === 568) {
                        setShowBreakFast(true)
                    } else if (data.id === 591) {
                        setShowEntress(true)
                    } else if (data.id === 592) {
                        setShowDrinks(true)
                    }else if (data.id === 593) {
                        setShowMexicam(true)
                    }else if (data.id === 571) {
                        setShowSaladas(true)
                    } else if (data.id === 569) {
                        setShowSandwiches(true)
                    } else {
                        setShowListProduct(true)
                        setdishs(data)    
                    }
                    
                }} style={{textDecoration: 'none',    borderRadius: 5,height: 42,}}>
                    <div style={{
                    height: 42,
                    display: 'flex',
                    flex: 1,
                    backgroundColor: '#fff',
                    justifyContent: 'center',
                    alignItems: 'center',
                      borderRadius: 3,
                     
                    
                    position: 'relative',
                }}>
                    <p style={{
                       
                        textAlign: 'center',
                        alignSelf: 'center',
                        textTransform: 'uppercase',
                        fontSize: 19,
                        margin: 0,
                        color: '#E50000',
                        fontWeight: '900',
                    }}>{langEng ? data.name : translate(i18n.language, data.language, data.name)}</p>
                    
                </div>
            </div>
                    
            </div>

           
        );
    }


     useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowListProduct(false);
            setShowDetailProduct(false)
            setShowEntress(false)
            setShowDrinks(false)
            setShowBreakFast(false)
            setShowMexicam(false)
           
            getInitData();
            

        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
    };
    


    return (
        <div style={{position: 'absolute', top: -6, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
        <LayoutContent showBack={false}>
            <div>
                <div onClick={() => {
                    setShowDetailProduct(true)
                    setDataDish({ dish: grilled, alldish: datasteak, currentDish: grilled })
                }} >
                    <img src={require('./assets/image.png')} style={{
                        width: '100%',
                        height: 200,
                        borderRadius: 14,
                        objectFit: "cover",
                       
                    }}/>
                </div>
               
                <div style={{display: 'flex', width: '100%', marginTop: 0}}>
                    <div style={{ width: '75%' }}>
                        <div style={{display: 'flex', width: '100%', justifyContent: 'space-between'}}>
                            <div onClick={() => {
                                setShowDetailProduct(true)
                            setDataDish({ dish: pulpo, alldish: fish.menus, currentDish: pulpo })
                            }} style={{width: '49%'}}>
                                 <video
                                    loop
                                    autoPlay
                                    muted
                                    style={{
                                        marginTop: 10,
                                        width: '100%',
                                        height: 320,
                                        objectFit: 'cover',
                                        borderRadius: 20
                                    }}
                                    src={require('./assets/pulpo.mp4')}
                                />
                            </div>
                                <div style={{ width: '49%' }} onClick={() => {
                                    // setShowListProduct(true), setdishs(dataDesserts)
                            }} >
                                <video
                                    loop
                                    autoPlay
                                    muted
                                    style={{
                                        marginTop: 10,
                                        width: '100%',
                                        height: 320,
                                        objectFit: 'cover',
                                        borderRadius: 20
                                    }}
                                    src={require('./assets/delivery.mp4')}
                                />
                             </div>
                        </div>


                        <div onClick={() => {
                           
                           setShowDetailProduct(true)
                            setDataDish({ dish: bandeja, alldish: colobmian, currentDish: bandeja })
                        }}
                            style={{width: '100%',  borderRadius: 20, }}
                        >
                            <img
                            style={{
                                width: '100%',
                                height: 300,
                                objectFit: 'cover',
                                    borderRadius: 20,
                                marginTop: 5
                            }}
                            src={require('./assets/image3.png')}
                            />
                            {/* <p style={{color: 'white', fontSize: 11}}>(1)Please inform the waiter if you have any type of allergic condition (2) Price subject to change without notice (3) 18% gratuity will be added to invoice $100+</p> */}
                        </div>
                        

                    </div>
                    <div style={{ width: '25%', paddingLeft: 12 }}>
                        

                        <div style={{overflow: 'scroll', height:630, marginTop: 10}}>
                            {menus.map((item, key) => {
                                if (item.id != 574 && item.id != 575 && item.id != 577 && item.id != 576 && item.id != 587 && item.id != 588 && item.id != 581 && item.id != 580 && item.id != 582 && item.id != 583) {
                                     return  <Categorie data={ item}  key={key} />
                                 }
                             })}
                        </div>
                       
                    </div>
                </div>
            </div>

            
             {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowListProduct}
                    setShowDetailProduct={setShowDetailProduct}
            />}

            {showEntress && <EntreesScreen setShowEntress={setShowEntress} />}
            {showDrinks && <DrinksScreen setShowDrinks={setShowDrinks} />}
            {showBreakFast && <BreakFastScreen setShowBreakFast={setShowBreakFast} />}
            {showMexicam && <MexicamScreen setShowMexicam={setShowMexicam} />}
            {showSaladas && <SaladasScreen setShowSaladas={setShowSaladas} />}
            {showSandwiches && <SandwichesScreen setShowSandwiches={setShowSandwiches} />}
            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}
            </LayoutContent>
            </div>
    );
}

export default Index;